module.exports = __webpack_public_path__ + "img/img116.16d290ea.svg";